import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { MultipleGabeImportJobsActionTypes } from '../actions/multiple-gabe-import-jobs.actions';
import { MultipleGabeImportJobsEntity } from '../../entities/multiple-gabe-import-jobs.entity';

export const GABE_IMPORTS_KEY = 'multipleGabeImportJobs';

export interface MultipleGabeImportJobsState extends EntityState<MultipleGabeImportJobsEntity> {
    fetched: boolean;
    latestUpdatedAt: Date;
}

const adapter = createEntityAdapter<MultipleGabeImportJobsEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

export const multipleGabeImportJobsReducer = createReducer(
    initialState,
    on(MultipleGabeImportJobsActionTypes.UpdateAll, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setAll(Payload, { ...state, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt }),
    ),
    on(MultipleGabeImportJobsActionTypes.UpdateOne, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(MultipleGabeImportJobsActionTypes.UpdateMany, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, {
            ...state,
            latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllMultipleGabeImportJobs = selectAll;
export const selectMultipleGabeImportJobsEntities = selectEntities;

export const selectMultipleGabeImportJobsFetched = (state: MultipleGabeImportJobsState) => state.fetched;
export const selectMultipleGabeImportJobsLatestUpdatedAt = (state: MultipleGabeImportJobsState) => state.latestUpdatedAt;
